import { Injectable, signal } from '@angular/core';

export interface Toast {
  id: number;
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
}

/**
 * Application-level service that queues and auto-dismisses toast notifications after 4 seconds.
 */
@Injectable({ providedIn: 'root' })
export class ToastService {
  private counter = 0;
  readonly toasts = signal<Toast[]>([]);

  success(message: string) { this.add(message, 'success'); }
  error(message: string) { this.add(message, 'error'); }
  warning(message: string) { this.add(message, 'warning'); }
  info(message: string) { this.add(message, 'info'); }

  private add(message: string, type: Toast['type']) {
    const id = ++this.counter;
    this.toasts.update(t => [...t, { id, message, type }]);
    setTimeout(() => this.dismiss(id), 4000);
  }

  dismiss(id: number) {
    this.toasts.update(t => t.filter(toast => toast.id !== id));
  }
}
